// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type LightBulb12CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const LightBulb12CircleFilled: FC<LightBulb12CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="12"
            height="12"
        >
            <path
                d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12Zm-.531-2.22c.146.147.322.22.529.22a.728.728 0 0 0 .531-.219.72.72 0 0 0 .221-.531h-1.5c0 .206.073.383.219.53ZM4.5 8v.75h3V8h-3ZM3.349 6.432c.233.448.564.804.995 1.068h3.312c.43-.264.762-.62.995-1.068C8.884 5.984 9 5.507 9 5c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 6 2c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 3 5c0 .507.116.984.349 1.432Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default LightBulb12CircleFilled;
